import { okrDetailConstants } from "../../constants/okr/okrDetails.constants";
import { okrDetailActions } from "../../actions/okr/okrDetails.actions";
import {isProgressFilterUsed} from '../../utils/okr';
import {
	buildFilterDataSet,
	filterSelectedDataFromFilterDataSet,
	getFilterParamsFromUrl,
	getOkrFilterCount,
	isNonDefaultKrStatusFilter,
	isTruthyOverdueParam,
	isUiFiltersAppliedInUrl,
	resolveSavedKrStatus,
	showGoalMetricsFromTeamExpCol,
	urlHasOkrFilters,
} from '../../utils/okrFilterParams.util';
import { setKeyResultsStatusInTeams } from '../../utils/closeKeyResult.util';
import i18next from 'i18next';

const parseStatusFromFilterSelectedData = (filterSelectedData) => {
	if (!filterSelectedData || typeof filterSelectedData.status === 'undefined'
		|| typeof filterSelectedData.status !== 'string' || !filterSelectedData.status) {
		return null;
	}
	const status = filterSelectedData.status;
	const isCsv = status.indexOf(',') !== -1;
	return {
		openOKR: isCsv ? status.includes(String(okrDetailConstants.GOAL_ACTIVE))
			: filterSelectedData.status == okrDetailConstants.GOAL_ACTIVE,
		closedOKR: isCsv ? status.includes(String(okrDetailConstants.GOAL_CLOSED))
			: filterSelectedData.status == okrDetailConstants.GOAL_CLOSED
	};
};
const initialState = {
	loading: true,
	teams: [],
	count: 0,
	filterCount: "",
	filterData: {
		onlyClosedGoals: false,
		onlyOpenGoals: true,
		statusSet: false
	},
	filterDateArray: [],
	dueStatus: false,
	filterOptions: [
		{
			name: i18next.t("Teams I manage"),
			value: "1"
		},
		{
			name: i18next.t("Teams I manage and co-manage"),
			value: "2"
		}
	],
	// KrFilterOptions: [
	// 	{
	// 		name: "Key results they update",
	// 		value: "1"
	// 	},
	// 	{
	// 		name: "Key results they own",
	// 		value: "2"
	// 	},
	// 	{
	// 		name: "Key results they own or update",
	// 		value: "3"
	// 	}
	// ],
	showKrRows: false,
	showGoalMetricList: true,
	fullAlignData: {},
	error: false,
	filterDataSet: {
		onlyClosedGoals: false,
		onlyOpenGoals: true,
		statusSet: false
	},
	teamsLength: 0,
	showLoader: false,
	showRealOwner: false,
	sophisticatedCount: 0,
	gs: 0,
	krOwnUpdate: 0,
	goals: {},
	clientFilterApplied: false,
}

const okrDetailsReducer = (state = initialState, action) => {
	switch (action.type) {
		case okrDetailConstants.UPDATE_INITIAL_PROPS:
			return Object.assign({}, state, action.data);
		case okrDetailConstants.SET_MY_OKR_STATUS:
			return Object.assign({}, state, {myOkrStatus: action.myOkrStatus});
		case okrDetailConstants.FILTERED_DATA:
			const newteamData = typeof action.rows !== 'undefined' ? action.rows : state.teams;
			const nextFilterDataSet = { ...action.filterDataSet };
			if (state.dueStatus === true) {
				nextFilterDataSet.overdueKR = 1;
			}
			const nextFilterSelectedData = filterSelectedDataFromFilterDataSet(nextFilterDataSet);
				return {
					...state,
					teams: newteamData,
					filterDataSet: nextFilterDataSet,
					filterSelectedData: nextFilterSelectedData,
					count: action.count,
					loading: false,
					showLoader: false,
					dueStatus: state.dueStatus,
					showGoalMetricList: state.showGoalMetricList,
					clientFilterApplied: true,
				}

		case okrDetailConstants.GET_GOAL_DETAILS_SUCCESS:
			let filterDataMyGoals, filterCountMyGoals;
			if (action.data.filterSelectedData) {
				filterDataMyGoals = {
					startDate: '',
					endDate: '',
					openOKR: true,
					closedOKR: false,
					dateOKR: true,
					performance: state.filterDataSet ? state.filterDataSet.performance : okrDetailConstants.FILTER_PROGRESS_DEFAULT,
					categories: '',
					krTags: []
				};
				filterCountMyGoals = 0;
				filterDataMyGoals.startDate = action.data.filterSelectedData.startDate;
				filterDataMyGoals.endDate = action.data.filterSelectedData.endDate;
				if(action.data.filterSelectedData.performance){
					filterDataMyGoals.performance = action.data.filterSelectedData.performance ;
				}
				filterDataMyGoals.categories = action.data.filterSelectedData.categories
					? action.data.filterSelectedData.categories : '';
				filterDataMyGoals.krTags = action.data.filterSelectedData.krtags
					? action.data.filterSelectedData.krtags : [];
				const parsedMyGoals = parseStatusFromFilterSelectedData(action.data.filterSelectedData);
				if (parsedMyGoals) {
					filterDataMyGoals.openOKR = parsedMyGoals.openOKR;
					filterDataMyGoals.closedOKR = parsedMyGoals.closedOKR;
				} else {
					if (state.filterDataSet) {
						filterDataMyGoals.openOKR = state.filterDataSet.onlyOpenGoals;
						filterDataMyGoals.closedOKR = state.filterDataSet.onlyClosedGoals;
					} else {
						filterDataMyGoals.openOKR = true;
						filterDataMyGoals.closedOKR = false;
					}
				}
				filterDataMyGoals.dateOKR = action.data.filterSelectedData.exDate == 1 ? true : false;
				if ((filterDataMyGoals.startDate && filterDataMyGoals.startDate != '')
					|| (filterDataMyGoals.endDate && filterDataMyGoals.endDate != '')) {
					filterCountMyGoals++;
				}
				if (filterDataMyGoals.closedOKR == true) {
					filterCountMyGoals++;
				}
				if(isProgressFilterUsed(filterDataMyGoals.performance)){
					filterCountMyGoals++;
				}
				if (filterDataMyGoals.categories != '' && filterDataMyGoals.categories != 0) {
					filterCountMyGoals++;
				}
				if (filterDataMyGoals.krTags.length > 0) {
					filterCountMyGoals++;
				}
			}
			removeLoaderWidget();
			let teamsData = state.teams;
			let newDataReceived = action.data.goals;
			if (teamsData.length > 0) {
				teamsData.map((team) => {
					if (newDataReceived.find(item => item.team_id === team.team_id)) {
						let existingTeam = newDataReceived.find(item => item.team_id === team.team_id);
						Object.assign(team.goals, team.goals.concat(existingTeam.goals));
					}
				})

				newDataReceived.map((team) => {
					if (!teamsData.find(item => item.team_id === team.team_id)) {
						teamsData.push(team)
					}
				})
			} else {
				teamsData = action.data.goals;

			}
			return {
				...state,
				displayKrConfidence: action.data['display_kr_confidence'],
				okrTeamOnlyPermssion: action.data['okr_teamOnly_Permission'],
				displayKrClustering: action.data['display_kr_clustering'],
				displayNestedKr: action.data['display_nested_kr'],
				teams: teamsData,
				showRealOwner: action.data.show_real_owner,
				teamsLength: teamsData.length,
				filterSelectedData: filterDataMyGoals ? filterDataMyGoals : state.filterSelectedData,
				count: filterCountMyGoals ? filterCountMyGoals : state.count,
				loading: false,
				gs: 0,
				showLoader: false,
				goals:action.data
			}
		case okrDetailConstants.GET_DIRECT_DOTTED_OKRS_SUCCESS:

			removeLoaderWidget();
			let directDottedData = state.teams;
			let newDirectDataRecieved = JSON.parse(JSON.stringify(action.data.goals));
			if (directDottedData.length > 0) {
				newDirectDataRecieved.forEach(newUserList => {
					let findUser = directDottedData.find(u => u.user_id == newUserList.user_id);
					if (findUser) {
						let findUserIndex = directDottedData.findIndex(u => u.user_id == newUserList.user_id);
						newUserList.teams.forEach(teamList => {
							let findTeam = directDottedData[findUserIndex].teams.find(t => t.team_id == teamList.team_id);
							let findTeamIndex = directDottedData[findUserIndex].teams.findIndex(t => t.team_id == teamList.team_id);
							if (findTeam) {
								findUser.teams[findTeamIndex].goals = findUser.teams[findTeamIndex].goals.concat(teamList.goals);
							} else {
								findUser.teams.push(teamList);
							}
						})
						directDottedData[findUserIndex] = findUser;
					}
					else {
						directDottedData.push(newUserList);
					}
				});
			} else {
				directDottedData = action.data.goals;
			}
			let filterData = {
				startDate: '',
				endDate: '',
				openOKR: true,
				closedOKR: false,
				dateOKR: true,
				performance: okrDetailConstants.FILTER_PROGRESS_DEFAULT,
				categories: '',
				krTags: []
			};
			let filterCount = 0;
			if (action.data.filterSelectedData) {
				filterCount = 0;
				filterData.startDate = action.data.filterSelectedData.startDate;
				filterData.endDate = action.data.filterSelectedData.endDate;
				const parsedDirect = parseStatusFromFilterSelectedData(action.data.filterSelectedData);
				if (parsedDirect) {
					filterData.openOKR = parsedDirect.openOKR;
					filterData.closedOKR = parsedDirect.closedOKR;
				}
				filterData.dateOKR = action.data.filterSelectedData.exDate == 1 ? true : false;
				filterData.performance = action.data.filterSelectedData.performance;
				filterData.categories = action.data.filterSelectedData.categories
					? action.data.filterSelectedData.categories : '';
				filterData.krTags = action.data.filterSelectedData.krtags
					? action.data.filterSelectedData.krtags : [];
				filterData.customFields = action.data.filterSelectedData.customFields
					? action.data.filterSelectedData.customFields : '';
				if ((filterData.startDate && filterData.startDate != '')
					|| (filterData.endDate && filterData.endDate != '')) {
					filterCount++;
				}
				if (filterData.closedOKR == true) {
					filterCount++;
				}
				if(isProgressFilterUsed(filterData.performance)){
					filterCount++;
				}
				if (filterData.categories != '' && filterData.categories != 0) {
					filterCount++;
				}
				if(filterData.krTags.length > 0){
					filterCount++;
				}
			}
			const directStatusCsv = filterData.openOKR && filterData.closedOKR
				? `${okrDetailConstants.GOAL_ACTIVE},${okrDetailConstants.GOAL_CLOSED}`
				: filterData.openOKR ? String(okrDetailConstants.GOAL_ACTIVE)
				: filterData.closedOKR ? String(okrDetailConstants.GOAL_CLOSED)
				: String(okrDetailConstants.GOAL_ACTIVE);
			const directFilterDataSet = action.data.filterSelectedData ? {
				onlyOpenGoals: filterData.openOKR,
				onlyClosedGoals: filterData.closedOKR,
				statusSet: filterData.openOKR && filterData.closedOKR,
				status: directStatusCsv,
				startDate: filterData.startDate,
				endDate: filterData.endDate,
				exDate: filterData.dateOKR ? 1 : 0,
				performance: filterData.performance || okrDetailConstants.FILTER_PROGRESS_DEFAULT,
				categories: filterData.categories,
				krTags: filterData.krTags,
				custom_tag_id: filterData.krTags?.map((tag) => tag.id).join(',') || '',
				customFields: typeof filterData.customFields !== 'undefined'
					? filterData.customFields
					: (action.data.filterSelectedData.customFields ?? ''),
			} : state.filterDataSet;
			const directOkrExpand = action.data.okrPreferences?.okrExpandCollpase
				|| action.data.okrPreferences?.okrPreferences?.okrExpandCollpase;
			const fromFilterApply = action.meta?.fromFilter === true && action.meta?.filterDataSet;
			const useClientFilters = action.meta?.clientFilterApplied === false
				? false
				: (fromFilterApply || state.clientFilterApplied === true);
			const resolvedFilterDataSet = fromFilterApply
				? action.meta.filterDataSet
				: (useClientFilters ? state.filterDataSet : directFilterDataSet);
			const resolvedFilterCount = action.meta?.filterCount !== undefined
				? action.meta.filterCount
				: (useClientFilters ? state.count : filterCount);
			const resolvedDueStatus = action.meta?.dueStatus === true
				? true
				: (action.meta?.dueStatus === false ? false : state.dueStatus);
			const resolvedShowGoalMetricList = typeof state.showGoalMetricList === 'boolean'
				? state.showGoalMetricList
				: showGoalMetricsFromTeamExpCol(directOkrExpand?.teamExpCol);
			return {
				...state,
				teams: directDottedData,
				loading: false,
				emojisData: action.data.emojisData,
				showGoalMetricList: resolvedShowGoalMetricList,
				teamsLength: directDottedData.length,
				showLoader: false,
				showRealOwner: action.data.show_real_owner,
				displayKrConfidence: action.data.display_kr_confidence,
				displayNestedKr: action.data.display_nested_kr,
				filterSelectedData: filterSelectedDataFromFilterDataSet(resolvedFilterDataSet),
				filterDataSet: resolvedFilterDataSet,
				count: resolvedFilterCount,
				clientFilterApplied: useClientFilters,
				dueStatus: resolvedDueStatus,
			}
		case okrDetailConstants.UPDATE_GOAL_DETAILS_SUCCESS:
			removeLoaderWidget();
			return {
				...state,
				teams: action.data.data,
				loading: false
			}

		case okrDetailConstants.GET_MY_GOALS_FILTERED:
			removeLoaderWidget();
			return {
				...state,
				teams: action.data,
				...state.filterData,
				onlyClosedGoals: false,
				loading: false
			}
		case okrDetailConstants.GET_FULL_ALIGN_DATA:
			removeLoaderWidget();
			let fullAlignData = action.data ? action.data : {};
			if(typeof state.fullAlignData.goals == "undefined"){
				return {
					...state,
					fullAlignData
				}
			}else{
				let fullDataGoals = state.fullAlignData.goals.concat(fullAlignData.goals);
				const uniqueData = [...new Map(fullDataGoals.map(item =>
					[item['id'], item])).values()];
				state.fullAlignData.goals = uniqueData;
				return {
					...state
				}
			}
		case okrDetailConstants.GET_KR_SOURCE_POPUP_DATA:
			if (Array.isArray(state.teams) && state.teams[0].goals) {
				return {
					...state,
					teams: state.teams.map((row) => {
						return {
							...row,
							goals: row.goals.map((goal) => {
								if (goal.id === action.payload.Ids.goalId) {
									return {
										...goal,
										goal_metrics: goal.goal_metrics.map((metric) => {
											if (metric.id === action.payload.Ids.metricId) {
												return {
													...metric,
													sourcePopupDetails: action.payload.data
												}
											}
                      else if (metric.id == action.payload.parentMetricId && typeof metric.nested_krs !== undefined) {
                        metric.nested_krs = metric.nested_krs.map(nestedMetric => {
                          if(nestedMetric.id == action.payload.Ids.metricId) {
                            return {
                              ...nestedMetric,
                              sourcePopupDetails: action.payload.data
                            }
                          }
                          return nestedMetric;
                        })
                      }
											return metric;
										})
									}
								}
								return goal;
							})
						}
					}),
					sophisticatedCount: state.sophisticatedCount + 1,
				}
			}
			else if (!Array.isArray(state.teams) && state.teams.metrics) {
				return {
					...state,
					teams: {
						...state.teams,
						metrics: state.teams.metrics.map((user) => {
							if (user.user_id === action.payload.Ids.userId) {
								return {
									...user,
									teams: user.teams.map((team) => {
										return {
											...team,
											metrics: team.metrics.map((metric) => {
												if (metric.id === action.payload.Ids.metricId) {
													return {
														...metric,
														sourcePopupDetails: action.payload.data
													}
												}
                        else if (metric.id == action.payload.parentMetricId && typeof metric.nested_krs !== undefined) {
                          metric.nested_krs = metric.nested_krs.map(nestedMetric => {
                            if(nestedMetric.id == action.payload.Ids.metricId) {
                              return {
                                ...nestedMetric,
                                sourcePopupDetails: action.payload.data
                              }
                            }
                            return nestedMetric;
                          })
                        }
												return metric;
											})
										};
									})
								}
							}
							return user;
						})
					}
				}
			}
			else if (Array.isArray(state.teams) && state.teams[0].teams) {
				return {
					...state,
					teams: state.teams.map((user) => {
						return {
							...user,
							teams: user.teams.map((team) => {
								return {
									...team,
									goals: team.goals.map((goal) => {
										if (goal.id === action.payload.Ids.goalId) {
											return {
												...goal,
												goal_metrics: goal.goal_metrics.map((metric) => {
													if (metric.id === action.payload.Ids.metricId) {
														return {
															...metric,
															sourcePopupDetails: action.payload.data
														}
													}
                          else if (metric.id == action.payload.parentMetricId && typeof metric.nested_krs !== undefined) {
                            metric.nested_krs = metric.nested_krs.map(nestedMetric => {
                              if(nestedMetric.id == action.payload.Ids.metricId) {
                                return {
                                  ...nestedMetric,
                                  sourcePopupDetails: action.payload.data
                                }
                              }
                              return nestedMetric;
                            })
                          }
													return metric;
												})
											}
										}
										return goal;
									})
								};
							})
						}
					})
				}
			}
			return {
				...state
			}
		case okrDetailConstants.UPDATE_WORKSTREAM_PROPS:
			return {
				...state,
				loading: false,
				teams: action.data.goals,
				showGoalMetricList: true,
				emojisData: action.data.emojisData,
				showLoader: false,
				showRealOwner: action.data.show_real_owner,
				displayKrConfidence: action.data.display_kr_confidence,
				displayNestedKr: action.data.display_nested_kr
			}
		case okrDetailConstants.GET_KRS_I_UPDATE_SUCCESS:
			removeLoaderWidget();
			return {
				...state,
				loading: false,
				teams: action.data
			}
		case okrDetailConstants.GET_DIRECT_DOTTED_KRS_SUCCESS: {
			removeLoaderWidget();
			let krData = state.teams;
			let krDataMetric = krData.metrics || [];
			let metricsData = [];
			if (krDataMetric.length > 0 && action.data.metrics) {
				let newKrDataRecieved = JSON.parse(JSON.stringify(action.data.metrics));
				newKrDataRecieved.forEach(newUserList => {
					let findUser = krDataMetric.find(u => u.user_id == newUserList.user_id);
					if (findUser) {
						let findUserIndex = krDataMetric.findIndex(u => u.user_id == newUserList.user_id);
						newUserList.teams.forEach(teamList => {
							let findTeam = findUser.teams.find(t => t.id == teamList.id && t.type == teamList.type);
							let findTeamIndex = findUser.teams.findIndex(t => t.id == teamList.id && t.type == teamList.type);
							if (findTeam) {
								Object.assign(findUser.teams[findTeamIndex].metrics, findUser.teams[findTeamIndex].metrics.concat(teamList.metrics));
							} else {
								findUser.teams.push(teamList);
							}
						});
						krData.metrics[findUserIndex] = findUser;
					}
					else {
						Object.assign(krData.metrics, krData.metrics.concat(newUserList));
					}
				});
				metricsData = krData;
			} else {
				metricsData = action.data;
			}
			let filterData = {
				startDate: '',
				endDate: '',
				openOKR: true,
				closedOKR: false,
				dateOKR: true,
				performance: okrDetailConstants.FILTER_PROGRESS_DEFAULT,
				categories: '',
				krTags: []
			};
			let filterCount = 0;
			if (action.data.filterSelectedData) {
				filterCount = 0;
				filterData.startDate = action.data.filterSelectedData.startDate;
				filterData.endDate = action.data.filterSelectedData.endDate;
				filterData.dateOKR = action.data.filterSelectedData.exDate == 1 ? true : false;
				filterData.performance = action.data.filterSelectedData.performance;
				filterData.krTags = action.data.filterSelectedData.krtags ? action.data.filterSelectedData.krtags : [];
				if ((filterData.startDate && filterData.startDate != '') || (filterData.endDate && filterData.endDate != '')) {
					filterCount++;
				}
				if(isProgressFilterUsed(filterData.performance)){
					filterCount++;
				}
				if(filterData.krTags.length > 0){
					filterCount++;
				}
			}
			const fromFilterApply = action.meta?.fromFilter === true && action.meta?.filterDataSet;
			const useClientFilters = action.meta?.clientFilterApplied === false
				? false
				: (fromFilterApply || state.clientFilterApplied === true);
			const resolvedFilterDataSet = fromFilterApply
				? action.meta.filterDataSet
				: state.filterDataSet;
			const resolvedFilterCount = action.meta?.filterCount !== undefined
				? action.meta.filterCount
				: filterCount;
			const resolvedFilterSelectedData = fromFilterApply
				? filterSelectedDataFromFilterDataSet(action.meta.filterDataSet)
				: (action.data.filterSelectedData ? filterData : state.filterSelectedData);
			const resolvedDueStatus = action.meta?.dueStatus === true
				? true
				: (action.meta?.dueStatus === false ? false : state.dueStatus);
			return {
				...state,
				displayKrConfidence: action.data.display_kr_confidence,
				displayNestedKr: action.data.display_nested_kr,
				...state.teams,
				teams: metricsData,
				showRealOwner: action.data.show_real_owner,
				loading: false,
				teamsLength: metricsData.length,
				showLoader: false,
				krOwnUpdate: action.data.kr_own_update,
				filterSelectedData: resolvedFilterSelectedData,
				filterDataSet: resolvedFilterDataSet,
				count: resolvedFilterCount,
				clientFilterApplied: useClientFilters,
				dueStatus: resolvedDueStatus,
			}
		} case okrDetailConstants.GET_TEAMS_OKR_SUCCESS:
			removeLoaderWidget();
			let teamsDataState = state.teams;
			var newTeamsDataRec = (typeof action.data.goals !== 'undefined' && action.data.goals.length > 0) ? action.data.goals : [];
			if (teamsDataState.length > 0) {
				if (action.data.overdueKR) {
					teamsDataState = action.data;
					delete teamsDataState.overdueKR;
				} else {
					teamsDataState.map((team) => {
						if (newTeamsDataRec.find(item => item.team_id === team.team_id)) {
							Object.assign(team.goals, team.goals.concat(newTeamsDataRec.filter(a => a.team_id == team.team_id )[0].goals));
						}
						newTeamsDataRec = newTeamsDataRec.filter(a => a.team_id != team.team_id );
					})
					if(newTeamsDataRec.length > 0) {
						newTeamsDataRec.map(data => {
							teamsDataState.push(data);
						})
					}
				}
			} else {
				teamsDataState = newTeamsDataRec;
			}

			return {
				...state,
				...state.teams,
				teams: teamsDataState,
				loading: false,
				teamsLength: teamsDataState.length,
				showLoader: false
			}
		case okrDetailConstants.RESET_LOADER:
			return {
				...state,
				loading: true
			}
		case okrDetailConstants.UPDATE_PERSON_SEARCH_RESULT: {
			removeLoaderWidget();
			let filterData = {
				startDate: '',
				endDate: '',
				openOKR: true,
				closedOKR: false,
				dateOKR: true,
				performance: okrDetailConstants.FILTER_PROGRESS_DEFAULT,
				categories: '',
				krTags: []
			};
			let filterCount = 0;
			if (action.data.filterSelectedData) {
				filterCount = 0;
				filterData.startDate = action.data.filterSelectedData.startDate;
				filterData.endDate = action.data.filterSelectedData.endDate;
				filterData.dateOKR = action.data.filterSelectedData.exDate == 1 ? true : false;
				filterData.performance = action.data.filterSelectedData.performance;
				filterData.krTags = action.data.filterSelectedData.krtags ? action.data.filterSelectedData.krtags : [];
				if ((filterData.startDate && filterData.startDate != '') || (filterData.endDate && filterData.endDate != '')) {
					filterCount++;
				}
				if(isProgressFilterUsed(filterData.performance)){
					filterCount++;
				}
				if(filterData.krTags.length > 0){
					filterCount++;
				}
			}
			return {
				...state,
				loading: false,
				teams: action.data,
				emojisData: action.data.emojisData,
				userData: action.data.userData,
				showRealOwner: action.data.show_real_owner,
				krOwnUpdate: action.data.kr_own_update,
				displayKrConfidence: action.data.display_kr_confidence,
				displayNestedKr: action.data.display_nested_kr,
				filterSelectedData: action.data.filterSelectedData ? filterData : '',
				count: filterCount,
				isPendoEnabled: action.data.isPendoEnabled
			}
		} case okrDetailConstants.OKR_ERROR_HANDLING:
			removeLoaderWidget();
			return {
				...state,
				error: true
			}
		case okrDetailConstants.UPDATE_INITIAL_TEAMS_DATA: {
			// console.log("Action.data",action.data);
			removeLoaderWidget();
			const savedKrStatus = action.data.filterSelectedData?.metricStatus;
			if (urlHasOkrFilters() || isUiFiltersAppliedInUrl()) {
				const urlParams = getFilterParamsFromUrl();
				urlParams.metricStatus = resolveSavedKrStatus(urlParams.metricStatus, savedKrStatus);
				const urlFilterDataSet = buildFilterDataSet(urlParams);
				const urlDueStatus = isTruthyOverdueParam(urlParams.overdueKR);
				if (urlDueStatus === true) {
					urlFilterDataSet.overdueKR = 1;
				}
				return {
					...state,
					loading: false,
					teams: action.data.goals,
					showRealOwner: action.data.show_real_owner,
					teamId: action.data.teamId,
					userId: action.data.userId,
					filterDataSet: urlFilterDataSet,
					filterSelectedData: filterSelectedDataFromFilterDataSet(urlFilterDataSet),
					count: getOkrFilterCount(urlParams),
					clientFilterApplied: true,
					dueStatus: urlDueStatus,
					emojisData: action.data.emojisData,
					showGoalMetricList: showGoalMetricsFromTeamExpCol(
						action.data.okrPreferences?.okrExpandCollpase?.teamExpCol
					),
					displayKrConfidence: action.data.display_kr_confidence,
					displayNestedKr: action.data.display_nested_kr
				};
			}
			let filterData = {
				startDate: '',
				endDate: '',
				openOKR: true,
				closedOKR: false,
				dateOKR: true,
				performance: okrDetailConstants.FILTER_PROGRESS_DEFAULT,
				categories: '',
				krTags: [],
				metricStatus: resolveSavedKrStatus(savedKrStatus),
			};
			let filterCount = 0;
			if (action.data.filterSelectedData) {
				filterCount = 0;
				filterData.startDate = action.data.filterSelectedData.startDate;
				filterData.endDate = action.data.filterSelectedData.endDate;
				const parsedTeams = parseStatusFromFilterSelectedData(action.data.filterSelectedData);
				if (parsedTeams) {
					filterData.openOKR = parsedTeams.openOKR;
					filterData.closedOKR = parsedTeams.closedOKR;
				}
				filterData.dateOKR = action.data.filterSelectedData.exDate == 1 ? true : false;
				filterData.performance = action.data.filterSelectedData.performance;
				filterData.categories = action.data.filterSelectedData.categories
					? action.data.filterSelectedData.categories : '';
				filterData.krTags = action.data.filterSelectedData.krtags
					? action.data.filterSelectedData.krtags : [];
				if ((filterData.startDate && filterData.startDate != '')
					|| (filterData.endDate && filterData.endDate != '')) {
					filterCount++;
				}
				if (filterData.closedOKR == true) {
					filterCount++;
				}
				if(isProgressFilterUsed(filterData.performance)){
					filterCount++;
				}
				if (filterData.categories != '' && filterData.categories != 0) {
					filterCount++;
				}
				if (filterData.krTags.length > 0) {
					filterCount++;
				}
				if (isNonDefaultKrStatusFilter(filterData.metricStatus)) {
					filterCount++;
				}
			}
			const statusCsv = filterData.openOKR && filterData.closedOKR
				? `${okrDetailConstants.GOAL_ACTIVE},${okrDetailConstants.GOAL_CLOSED}`
				: filterData.openOKR ? String(okrDetailConstants.GOAL_ACTIVE)
				: filterData.closedOKR ? String(okrDetailConstants.GOAL_CLOSED)
				: String(okrDetailConstants.GOAL_ACTIVE);
			const filterDataSet = (action.data.filterSelectedData || action.data.urlData) ? {
				onlyOpenGoals: filterData.openOKR,
				onlyClosedGoals: filterData.closedOKR,
				statusSet: filterData.openOKR && filterData.closedOKR,
				status: statusCsv,
				startDate: filterData.startDate,
				endDate: filterData.endDate,
				exDate: filterData.dateOKR ? 1 : 0,
				performance: filterData.performance || okrDetailConstants.FILTER_PROGRESS_DEFAULT,
				categories: filterData.categories,
				krTags: filterData.krTags,
				metricStatus: filterData.metricStatus,
			} : state.filterDataSet;
			return {
				...state,
				loading: false,
				teams: action.data.goals,
				showRealOwner: action.data.show_real_owner,
				teamId: action.data.teamId,
				userId: action.data.userId,
				filterDataSet,
				filterSelectedData: action.data.filterSelectedData || action.data.urlData ? filterData : '',
				count: filterCount,
				emojisData: action.data.emojisData,
				showGoalMetricList: showGoalMetricsFromTeamExpCol(
					action.data.okrPreferences?.okrExpandCollpase?.teamExpCol
				),
				displayKrConfidence: action.data.display_kr_confidence,
				displayNestedKr: action.data.display_nested_kr
			}
		} case okrDetailConstants.HANDLE_OVERDUE_KR: {
			const toggledDueStatus = !state.dueStatus;
			const toggledFilterDataSet = { ...state.filterDataSet };
			if (toggledDueStatus === true) {
				toggledFilterDataSet.overdueKR = 1;
			} else {
				delete toggledFilterDataSet.overdueKR;
			}
			return {
				...state,
				dueStatus: toggledDueStatus,
				filterDataSet: toggledFilterDataSet,
				showGoalMetricList: state.showGoalMetricList,
			};
		}

		case okrDetailConstants.SYNC_OVERDUE_STATUS:
			return {
				...state,
				dueStatus: action.dueStatus === true,
			}

		case okrDetailConstants.RESET_HANDLE_OVERDUE_KR:
			return {
				...state,
				dueStatus: false
			}

		case okrDetailConstants.UPDATE_OVERDUE_KR_SUCCESS:
			removeLoaderWidget();
			const overdueTeams = Array.isArray(action.data)
				? action.data
				: (action.data.goals || []);
			const overdueFilterDataSet = { ...state.filterDataSet, overdueKR: 1 };
			return {
				...state,
				teams: overdueTeams,
				teamsLength: overdueTeams.length,
				loading: false,
				showLoader: false,
				dueStatus: true,
				filterDataSet: overdueFilterDataSet,
				showGoalMetricList: state.showGoalMetricList,
			}
		case okrDetailConstants.GET_MY_MANAGER_OKR_SUCCESS:
			removeLoaderWidget();

			let filterDataMyManager;
			let filterCountMyManager;
			if (action.data.filterSelectedData) {
				filterDataMyManager = {
					startDate: '',
					endDate: '',
					openOKR: true,
					closedOKR: false,
					dateOKR: true,
					performance: state.filterDataSet ? state.filterDataSet.performance : okrDetailConstants.FILTER_PROGRESS_DEFAULT,
					categories: '',
					krTags: []
				};
				filterCountMyManager = 0;
				filterDataMyManager.startDate = action.data.filterSelectedData.startDate;
				filterDataMyManager.endDate = action.data.filterSelectedData.endDate;
				if(action.data.filterSelectedData.performance){
					filterDataMyManager.performance = action.data.filterSelectedData.performance;
				}
				filterDataMyManager.categories = action.data.filterSelectedData.categories
					? action.data.filterSelectedData.categories : '';
				filterDataMyManager.krTags = action.data.filterSelectedData.krtags
					? action.data.filterSelectedData.krtags : [];
				const parsedManager = parseStatusFromFilterSelectedData(action.data.filterSelectedData);
				if (parsedManager) {
					filterDataMyManager.openOKR = parsedManager.openOKR;
					filterDataMyManager.closedOKR = parsedManager.closedOKR;
				} else {
					if (state.filterDataSet) {
						filterDataMyManager.openOKR = state.filterDataSet.onlyOpenGoals;
						filterDataMyManager.closedOKR = state.filterDataSet.onlyClosedGoals;
					} else {
						filterDataMyManager.openOKR = true;
						filterDataMyManager.closedOKR = false;
					}
				}
				filterDataMyManager.dateOKR = action.data.filterSelectedData.exDate == 1 ? true : false;
				if ((filterDataMyManager.startDate && filterDataMyManager.startDate != '')
					|| (filterDataMyManager.endDate && filterDataMyManager.endDate != '')) {
					filterCountMyManager++;
				}
				if (filterDataMyManager.closedOKR == true) {
					filterCountMyManager++;
				}
				if(isProgressFilterUsed(filterDataMyManager.performance)){
					filterCountMyManager++;
				}
				if (filterDataMyManager.categories != '' && filterDataMyManager.categories != 0) {
					filterCountMyManager++;
				}
				if (filterDataMyManager.krTags.length > 0) {
					filterCountMyManager++;
				}
			}

			let manageTeamsData = state.teams;
			let newlyRecievedData = action.data.goals || [];
			if (manageTeamsData.length > 0) {
				manageTeamsData.map((team) => {
					if (newlyRecievedData.find(item => item.team_id === team.team_id)) {
						let existingTeam = newlyRecievedData.find(item => item.team_id === team.team_id);
						Object.assign(team.goals, team.goals.concat(existingTeam.goals));
					}
				})

				newlyRecievedData.map((team) => {
					if (!manageTeamsData.find(item => item.team_id === team.team_id)) {
						manageTeamsData.push(team)
					}
				})
			} else {
				manageTeamsData = action.data.goals || [];
			}
			return {
				...state,
				// ...state.teams,
				teams: manageTeamsData,
				showRealOwner: action.data.show_real_owner,
				loading: false,
				teamsLength: manageTeamsData.length,
				gs: 0,
				filterSelectedData: filterDataMyManager ? filterDataMyManager : state.filterSelectedData,
				count: filterCountMyManager ? filterCountMyManager : state.count,
				// filterSelectedData: action.data.filterSelectedData ? filterDataMyManager : '',
				// count: filterCountMyManager ? filterCountMyManager : state.count,
				showLoader: false,
				displayKrConfidence: action.data.display_kr_confidence,
				displayNestedKr: action.data.display_nested_kr
			}
		case okrDetailConstants.GET_MY_TEAMS_OKR_SUCCESS:
			removeLoaderWidget();

			let filterDataMyTeams;
			let filterCountMyTeams;
			if (action.data.filterSelectedData) {
				filterDataMyTeams = {
					startDate: '',
					endDate: '',
					openOKR: true,
					closedOKR: false,
					dateOKR: true,
					performance: state.filterDataSet ? state.filterDataSet.performance : okrDetailConstants.FILTER_PROGRESS_DEFAULT,
					categories: '',
					krTags: []
				};
				filterCountMyTeams = 0;
				filterDataMyTeams.startDate = action.data.filterSelectedData.startDate;
				filterDataMyTeams.endDate = action.data.filterSelectedData.endDate;
				if(action.data.filterSelectedData.performance){
					filterDataMyTeams.performance = action.data.filterSelectedData.performance;
				}
				filterDataMyTeams.categories = action.data.filterSelectedData.categories
					? action.data.filterSelectedData.categories : '';
				filterDataMyTeams.krTags = action.data.filterSelectedData.krtags
					? action.data.filterSelectedData.krtags : [];
				const parsedTeams = parseStatusFromFilterSelectedData(action.data.filterSelectedData);
				if (parsedTeams) {
					filterDataMyTeams.openOKR = parsedTeams.openOKR;
					filterDataMyTeams.closedOKR = parsedTeams.closedOKR;
				} else {
					if (state.filterDataSet) {
						filterDataMyTeams.openOKR = state.filterDataSet.onlyOpenGoals;
						filterDataMyTeams.closedOKR = state.filterDataSet.onlyClosedGoals;
					} else {
						filterDataMyTeams.openOKR = true;
						filterDataMyTeams.closedOKR = false;
					}
				}
				filterDataMyTeams.dateOKR = action.data.filterSelectedData.exDate == 1 ? true : false;
				if ((filterDataMyTeams.startDate && filterDataMyTeams.startDate != '')
					|| (filterDataMyTeams.endDate && filterDataMyTeams.endDate != '')) {
					filterCountMyTeams++;
				}
				if (filterDataMyTeams.closedOKR == true) {
					filterCountMyTeams++;
				}
				if(isProgressFilterUsed(filterDataMyTeams.performance)){
					filterCountMyTeams++;
				}
				if (filterDataMyTeams.categories != '' && filterDataMyTeams.categories != 0) {
					filterCountMyTeams++;
				}
				if (filterDataMyTeams.krTags.length > 0) {
					filterCountMyTeams++;
				}
			}

			let myTeamsData = state.teams;
			let newTeamsDataRecieved = action.data.goals || [];
			if (myTeamsData.length > 0) {
				myTeamsData.map((team) => {
					if (newTeamsDataRecieved.find(item => item.team_id === team.team_id)) {
						let existingTeam = newTeamsDataRecieved.find(item => item.team_id === team.team_id);
						Object.assign(team.goals, team.goals.concat(existingTeam.goals));
					}
				})

				newTeamsDataRecieved.map((team) => {
					if (!myTeamsData.find(item => item.team_id === team.team_id)) {
						myTeamsData.push(team)
					}
				})
			} else {
				myTeamsData = action.data.goals || [];
			}
			return {
				...state,
				...state.teams,
				teams: myTeamsData,
				teamsLength: myTeamsData.length,
				showRealOwner: action.data.show_real_owner,
				gs: 0,
				// filterSelectedData: action.data.filterSelectedData ? filterDataMyTeams : '',
				// count: filterCountMyTeams,
				filterSelectedData: filterDataMyTeams ? filterDataMyTeams : state.filterSelectedData,
				count: filterCountMyTeams ? filterCountMyTeams : state.count,
				loading: false,
				showLoader: false,
				displayKrConfidence: action.data.display_kr_confidence,
				displayNestedKr: action.data.display_nested_kr
			}
		case okrDetailConstants.RESET_GOAL_DATA:
			return {
				...state,
				teams: [],
				loading: true,
			}
		case okrDetailConstants.UPDATE_KR_REACTED_EMOJI:
			removeLoaderWidget();
			let teamsValue = Object.values(state.teams);
			if (Array.isArray(state.teams) && state.teams[0].goals) {
				teamsValue.forEach(team => {
					team.goals.forEach(goal => {
						if (goal.id == action.data.goal_id) {
							goal.goal_metrics.forEach(metric => {
								if (metric.id == action.data.obj_id) {
									metric.reacted_emojis = action.data.reacted_emojis;
									metric.emoji_count = action.data.reacted_emojis.reduce((prev, emoji) => prev + parseInt(emoji.count), 0);
								} else if (metric.id == action.data.parent_metric_id && typeof metric.nested_krs != "undefined") {
									 metric.nested_krs.forEach(nestedMetric => {
										if(nestedMetric.id == action.data.obj_id) {
											nestedMetric.reacted_emojis = action.data.reacted_emojis;
											nestedMetric.emoji_count = action.data.reacted_emojis.reduce((prev, emoji) => prev + parseInt(emoji.count), 0);
										}
									})
								}
							})
						}

					})
				})
			} else if (Array.isArray(state.teams) && state.teams[0].teams) {
				teamsValue.forEach(teamsList => {
					teamsList.teams.forEach(team => {
						team.goals.forEach(goal => {
							if (goal.id == action.data.goal_id) {
								goal.goal_metrics.forEach(metric => {
									if (metric.id == action.data.obj_id) {
										metric.reacted_emojis = action.data.reacted_emojis;
										metric.emoji_count = action.data.reacted_emojis.reduce((prev, emoji) => prev + parseInt(emoji.count), 0);
									} else if (metric.id == action.data.parent_metric_id && typeof metric.nested_krs != "undefined") {
                     metric.nested_krs.forEach(nestedMetric => {
											if(nestedMetric.id == action.data.obj_id) {
												nestedMetric.reacted_emojis = action.data.reacted_emojis;
												nestedMetric.emoji_count = action.data.reacted_emojis.reduce((prev, emoji) => prev + parseInt(emoji.count), 0);
											}
										})
									}
								})
							}

						})
					})
				})
			} else if (!Array.isArray(state.teams) && state.teams.metrics) {
				let teamsValue = Object.values(state.teams.metrics);
				teamsValue.forEach(teamsList => {
					teamsList.teams.forEach(team => {
						team.metrics.forEach(metric => {
							// console.log("metric", metric);
							if (metric.id == action.data.obj_id) {
								metric.reacted_emojis = action.data.reacted_emojis;
								metric.emoji_count = action.data.reacted_emojis.reduce((prev, emoji) => prev + parseInt(emoji.count), 0);
							} else if (metric.id == action.data.parent_metric_id && typeof metric.nested_krs != "undefined") {
                metric.nested_krs.forEach(nestedMetric => {
									if(nestedMetric.id == action.data.obj_id) {
										nestedMetric.reacted_emojis = action.data.reacted_emojis;
										nestedMetric.emoji_count = action.data.reacted_emojis.reduce((prev, emoji) => prev + parseInt(emoji.count), 0);
									}
								})
							}
						})
					})
				})
			}
			return { ...state };
		case okrDetailConstants.UPDATE_SHORT_CUT_BAR_SUCCESS:
			return {
				...state,
				teams: state.teams.map((row) => {
					return {
						...row,
						goals: row.goals.map((goal) => {
							if (goal.id === action.data.goalId) {
								return {
									...goal,
									showShortCutOKR: action.data.status
								}
							}
							return goal;
						})
					}
				})
			}
		case okrDetailConstants.UPDATE_COMMENT_COUNT:
			let goalId = action.params.goal_id;
			let metId = action.params.metric_id;
			let parentMetId = action.params.parentMetricId;
			let actionType = action.params.actionType;
			let commentCnt = action.params.commentCnt || 0;

			let teamsValues = Object.values(state.teams);
			if (Array.isArray(state.teams) && state.teams.length && state.teams[0].goals) {
				teamsValues.forEach(team => {
					team.goals.forEach(goal => {
						if (goal.id == goalId) {
							goal.goal_metrics.forEach(metric => {
								if (metric.id == metId) {
									let comCount = parseInt(metric.comment_count);
									if (actionType == 'sub') {
										comCount = (comCount == 0 || comCount < 0) ? 0 : comCount - 1;
									} else if (actionType == 'update') {
										comCount = commentCnt;
									} else {
										comCount = comCount + 1;
									}
									metric.comment_count = comCount;
								} else if (metric.id == parentMetId && typeof metric.nested_krs != "undefined" ) {
                   metric.nested_krs.forEach(nestedMetric => {
										if(nestedMetric.id == metId) {
											let comCount = parseInt(nestedMetric.comment_count);
											if (actionType == 'sub') {
												comCount = (comCount == 0 || comCount < 0) ? 0 : comCount - 1;
											} else if (actionType == 'update') {
												comCount = commentCnt;
											} else {
												comCount = comCount + 1;
											}
											nestedMetric.comment_count = comCount;
										}
									})
								}
							})
						}
					})
				})
			} else if (Array.isArray(state.teams) && state.teams.length && state.teams[0].teams) {
				teamsValues.forEach(teamsList => {
					teamsList.teams.forEach(team => {
						team.goals.forEach(goal => {
							if (goal.id == goalId) {
								goal.goal_metrics.forEach(metric => {
									if (metric.id == metId) {
										let comCount = parseInt(metric.comment_count);
										if (actionType == 'sub') {
											comCount = (comCount == 0 || comCount < 0) ? 0 : comCount - 1;
										} else if (actionType == 'update') {
											comCount = commentCnt;
										} else {
											comCount = comCount + 1;
										}
										metric.comment_count = comCount;
									} else if (metric.id == parentMetId && typeof metric.nested_krs != "undefined") {
                    metric.nested_krs.forEach(nestedMetric => {
											if(nestedMetric.id == metId) {
												let comCount = parseInt(nestedMetric.comment_count);
												if (actionType == 'sub') {
													comCount = (comCount == 0 || comCount < 0) ? 0 : comCount - 1;
												} else if (actionType == 'update') {
													comCount = commentCnt;
												} else {
													comCount = comCount + 1;
												}
												nestedMetric.comment_count = comCount;
											}
										})
									}
								})
							}

						})
					})
				})
			} else if (!Array.isArray(state.teams) && state.teams.metrics) {
				let teamsValues = Object.values(state.teams.metrics);
				teamsValues.forEach(teamsList => {
					teamsList.teams.forEach(team => {
						team.metrics.forEach(metric => {
							if (metric.id == metId) {
								let comCount = parseInt(metric.comment_count);
								if (actionType == 'sub') {
									comCount = (comCount == 0 || comCount < 0) ? 0 : comCount - 1;
								} else if (actionType == 'update') {
									comCount = commentCnt;
								} else {
									comCount = comCount + 1;
								}
								metric.comment_count = comCount;
							} else if (metric.id == parentMetId && typeof metric.nested_krs != "undefined") {
                metric.nested_krs.forEach(nestedMetric => {
									if(nestedMetric.id == metId) {
										let comCount = parseInt(nestedMetric.comment_count);
										if (actionType == 'sub') {
											comCount = (comCount == 0 || comCount < 0) ? 0 : comCount - 1;
										} else if (actionType == 'update') {
											comCount = commentCnt;
										} else {
											comCount = comCount + 1;
										}
										nestedMetric.comment_count = comCount;
									}
								})
							}
						})
					})
				})
			}
			return {
				...state
			}
		case okrDetailConstants.UPDATE_DIRECT_DOTTED_GOAL:

			const _goals = action.data.goals;
			const typeAction = action.data.actionType;

			if (typeof _goals[0] !== 'undefined' && _goals[0] != null) {
				const _goal = _goals[0];
				let _rows1 = state.teams || [];
				const teamId = parseInt(_goal.team_id) > 0 ? _goal.team_id : "0";
				if (typeAction == "edit" || typeAction == "editCurrent") {
					const goalStatus = _goal.status;
					if (goalStatus == "1" || typeAction == "editCurrent") {
						return {
							...state,
							teams: state.teams.map((user) => {
								return {
									...user,
									teams: user.teams.map((team) => {
										return {
											...team,
											goals: team.goals.map((goal) => {
												if (goal.id === _goal.id) {
													return Object.assign({}, goal, _goal)
												}
												return goal;
											})
										};
									})
								}
							})
						}

					}
				}
			}

		case okrDetailConstants.GET_SINGLE_KR_DETAILS:
			return {
				...state,
				teams: {
					...state.teams,
					metrics: state.teams.metrics.map((user) => {
						return {
							...user,
							teams: user.teams.map((team) => {
								return {
									...team,
									metrics: team.metrics.map((metric) => {
										if (metric.id === action.data.id) {
											return Object.assign({}, metric, action.data)
										}
										return metric;
									})
								};
							})
						}
					})
				}
			}

		case okrDetailConstants.EXCLUDE_KR_FROM_LIST:
			return {
				...state,
				teams: {
					...state.teams,
					metrics: state.teams.metrics.map((user) => {
						return {
							...user,
							teams: user.teams.map((team) => {
								return {
									...team,
									metrics: team.metrics.filter(metric => metric.id !== action.data)

								};
							})
						}
					})
				}
			}

		case okrDetailConstants.DELETE_SINGLE_KR:
			return {
				...state,
				teams: {
					...state.teams,
					metrics: state.teams.metrics.map((user) => {
						return {
							...user,
							teams: user.teams.map((team) => {
								return {
									...team,
									metrics: team.metrics.filter(metric => metric.id !== action.data.id)
								};
							})
						}
					})
				}
			}

		case okrDetailConstants.UPDATE_DIRECT_DOTTED_KR:
			return {
				...state,
				teams: {
					...state.teams,
					metrics: state.teams.metrics.map((user) => {
						return {
							...user,
							teams: user.teams.map((team) => {
								return {
									...team,
									metrics: team.metrics.map((metric) => {
										// console.log("metric--->",metric);
										if (action.data && metric.id === action.data.id) {
											return Object.assign({}, metric, action.data)
										}
										return metric;
									})
								};
							})
						}
					})
				}
			}

		case okrDetailConstants.DELETE_DIRECT_DOTTED_KR:
			return {
				...state,
				teams: {
					...state.teams,
					metrics: state.teams.metrics.map((user) => {
						return {
							...user,
							teams: user.teams.map((team) => {
								return {
									...team,
									metrics: team.metrics.filter(metric => metric.id !== action.data.id)
								};
							})
						}
					})
				}
			}

		case okrDetailConstants.PERSON_DUE_KEY_RESULTS:
			removeLoaderWidget();
			let krData1 = state.teams;
			let krDataMetric1 = krData1.metrics || [];
			let metricsData1 = [];
			let newKrDataRecieved1 = action.data.data.metrics;
			if (krDataMetric1.length > 0) {
				newKrDataRecieved1.forEach(newUserList => {
					let findUser = krDataMetric1[0];
					if (findUser) {
						newUserList.teams.forEach(teamList => {
							let findTeam = findUser.teams.find(t => t.id == teamList.id && t.type == teamList.type);
							let findTeamIndex = findUser.teams.findIndex(t => t.id == teamList.id && t.type == teamList.type);
							if (findTeam) {
								Object.assign(findUser.teams[findTeamIndex].metrics, findUser.teams[findTeamIndex].metrics.concat(teamList.metrics));
							} else {
								findUser.teams.push(teamList);
							}
						});

						krData1.metrics[0] = findUser;
					}
					else {
						Object.assign(krData1.metrics, krData1.metrics.concat(newUserList));
					}
				});
				metricsData1 = krData1;
			} else {
				metricsData1 = action.data.data;
			}
			return {
				...state,
				teams: metricsData1,
				loading: false,
				showLoader: false,
			}

		case okrDetailConstants.UPDATE_SHOW_HIDE_METRIC:
			return {
				...state,
				showGoalMetricList: !state.showGoalMetricList
			}
		case okrDetailConstants.RESET_FILTER_COUNT:
			if (typeof state.filterDataSet !== 'undefined') {
				delete state.filterDataSet;
				delete state.filterSelectedData;
			}
			return {
				...state,
				count: 0
			}
		case okrDetailConstants.RESET_FILTER_COUNT_ONCLOSE:
			return {
				...state,
				count: 0
			}
		case okrDetailConstants.OVERDUE_KEY_RESULTS_TEAM:
			removeLoaderWidget();
			return {
				...state,
				teams: action.data.goals,
				loading: false,
				showGoalMetricList: state.showGoalMetricList,
			}
		case okrDetailConstants.DIRECT_DOTTED_OKR_DELETE_SUCCESS:
			return {
				...state,
				teams: state.teams.map((user) => {
					return {
						...user,
						teams: user.teams.map((team) => {
							return {
								...team,
								goals: team.goals.filter(goal => goal.id !== action.data.goalId)
							};
						})
					}
				})
			}
		case okrDetailConstants.REMOVE_CREATE_CASCADE_CARD:
			let id = action.data;
			const { [id]: _, ...newCascade } = state.teams.cascadeList;
			return {
				...state,
				teams: {
					...state.teams,
					cascadeList: newCascade
				}
			}
		case okrDetailConstants.UPDATE_CASCADE_KR_LIST:
			return {
				...state,
				teams: {
					...state.teams,
					metrics: state.teams.metrics.map((user) => {
						return {
							...user,
							teams: user.teams.map((team) => {
								if (team.id == "-1") {
									let existsdata = team.metrics.find(metric => (metric.id == action.data.id));
									if (existsdata) {
										let metricsData = team.metrics.filter(metric => (metric.id !== existsdata.id));
										team.metrics = metricsData;
									}
									Object.assign(team.metrics, team.metrics.concat(action.data));
									return team;
								}
								return team;
							})
						}
					})
				}
			}
		case okrDetailConstants.DELETE_CASCADE_KR_FROM_LIST:
			// console.log("action.data--",action.data);
			return {
				...state,
				teams: {
					...state.teams,
					metrics: state.teams.metrics.map((user) => {
						return {
							...user,
							teams: user.teams.map((team) => {
								return {
									...team,
									metrics: team.metrics.filter(metric => metric.id !== action.data)
								};
							})
						}
					})
				}
			}
		case okrDetailConstants.SHOW_PAGINATION_LOADER:
			return {
				...state,
				showLoader: true
			}
		case okrDetailConstants.UPDATE_FILTER_PREFERENCES:
			return {
				...state,
				okrPreferences: {
					...state.okrPreferences,
					filters: {
						...state.okrPreferences.filters,
						show: action.data
					}
				}
			}
		case okrDetailConstants.RESET_FULL_ALIGNMENT:
			return {
				...state,
				fullAlignData: {}
			}
		case okrDetailConstants.RESET_TEAMS_GOAL_DATA:
			return {
				...state,
				teams: [],
				loading: false
			}
		case okrDetailConstants.ADD_NEW_KR:

			console.log(action);
			console.log('teams', state.teams);
			let modifiedTeams;
			if(Array.isArray(state.teams) && state.teams.length > 0){
				modifiedTeams = [...state.teams] ;
				const myTeam = modifiedTeams.find((team) => team.team_id == action.teamId);
				if(myTeam){
					const myGoal = myTeam.goals.find((goal) => goal.id == action.item.goal_id);
					myGoal.goal_metrics = [...myGoal.goal_metrics, action.item];
				}
			}else if(state.teams && state.teams.metrics){
				modifiedTeams = {...state.teams}
				const metricsByUser = modifiedTeams.metrics.find((byUser) => byUser.user_id == action.item.user_id);
				if(metricsByUser){
					const myTeam = metricsByUser.teams.find((team) => team.id ==  action.teamId);
					myTeam.metrics = [...myTeam.metrics, action.item]
					// .map((metric) => {
					// 	if(metric.id == action.item.id){
					// 		return {...action.item}
					// 	}
					// 	return metric;
					// })
				}
			}
			console.log("addKr modifiedTeams",modifiedTeams)
			return {
				...state,
				teams: modifiedTeams
			}
		case okrDetailConstants.DELETE_KR:
			let newTeams;
			if(Array.isArray(state.teams) && state.teams.length > 0){
				newTeams = [...state.teams];
				console.log("deletekr actions" , action);
				if(newTeams && newTeams.length > 0){
					const myTeam = newTeams.find((team) => team.team_id == action.teamId);
					if(myTeam){
						const myGoal = myTeam.goals.find((goal) => goal.id == action.goalId);
						myGoal.goal_metrics = myGoal.goal_metrics.filter((met) => met.id != action.krId)
					}

				}
			}else if(state.teams && state.teams.metrics){
				newTeams = {...state.teams}
				const metricsByUser = newTeams.metrics.find((byUser) => byUser.user_id == action.userId);
				if(metricsByUser){
					const myTeam = metricsByUser.teams.find((team) => team.id ==  action.teamId);
					myTeam.metrics = myTeam.metrics.filter((metric) => {
						return metric.id != action.krId;
					})
				}
			}

			console.log("deleteKr modifiedTeams", newTeams)
			return {
				...state,
				teams: newTeams
			}
		case okrDetailConstants.SET_KEY_RESULTS_STATUS:
			if (!Array.isArray(state.teams)) {
				return state;
			}
			return {
				...state,
				teams: setKeyResultsStatusInTeams(state.teams, action.metricIds, action.status),
			};
		default:
			return state;
	}

}

export default okrDetailsReducer;